import { Provider } from "react-redux";
import { store } from "store";
import { PDFLaborOldFullWrapper } from "./PDFLaborOldFullWrapper";

export const PDFLaborOldFullProvider: React.FC = () => {
  return (
    <Provider store={store}>
      <PDFLaborOldFullWrapper />
    </Provider>
  );
};
